import { useState } from 'react';

import { useWindowSize } from '@/utils/WindowSizeProvider';
import { getAutocompleteResults } from '@/utils/fetch/kayak/kayakFetcher';

import type { AutocompleteDestination } from '@/interfaces';
import { Autocomplete } from '@/components/autocomplete/Autocomplete';
import { InputErrors } from '@/components/inputErrors/InputErrors';

export interface DestinationAutocompleteProps {
    updateDestination: (destination?: AutocompleteDestination) => void;
    defaultDestination?: string;
    errors?: readonly string[];
}

export const DestinationAutocomplete = ({ updateDestination, defaultDestination, errors = [] }: DestinationAutocompleteProps) => {
    const { isMobile } = useWindowSize();
    const [autocompleteText, setAutocompleteText] = useState(defaultDestination || '');
    const fetchOptions = (searchTerm: string) => getAutocompleteResults(searchTerm);

    const setDestination = (destination?: AutocompleteDestination): void => {
        updateDestination(destination);
    };

    const onClick = (destination?: AutocompleteDestination): void => {
        if (destination) {
            setAutocompleteText(destination.text);
            setDestination(destination);
        } else {
            setAutocompleteText('');
            setDestination(undefined);
        }
    };

    return (
        <div className={`input u-mb0 input--select ${errors.length > 0 ? ' input--is-invalid' : ''}`}>
            <div className="input--select__wrap u-mb32 destination-autocomplete" data-testid="destinationAutocomplete">
                <Autocomplete
                    id="destination"
                    label="Destinasjon"
                    value={autocompleteText}
                    fetchOptions={fetchOptions}
                    onClick={onClick}
                    onTextChange={setAutocompleteText}
                    minimumCharacters={2}
                    isMobile={isMobile}
                />
                <InputErrors errors={errors} />
            </div>
        </div>
    );
};
